import { PresetPicker } from "./preset-picker.tsx";

const PARTY_SIZE_OPTIONS = [
  "2 people",
  "3 people",
  "4 people",
  "5 people",
  "6 people",
  "7 people",
  "8+ people",
];

/** Default selected index — "2 people" is index 0. */
const DEFAULT_INDEX = 0;

interface PartySizePickerProps {
  onSelect: (partySize: string) => void;
  defaultValue?: string | null;
}

/** Single-select party size picker with preset options and custom input. */
export function PartySizePicker({ onSelect, defaultValue }: PartySizePickerProps) {
  return (
    <PresetPicker
      options={PARTY_SIZE_OPTIONS}
      onSelect={onSelect}
      defaultValue={defaultValue}
      defaultIndex={DEFAULT_INDEX}
      placeholder="How many people?"
      ariaLabel="Party size options"
      layout="pills"
    />
  );
}
